import React, { useState } from "react";
import CalendarView from "./CalendarView";
import DeliveryTracking from "./DeliveryTracking";
import UserProfileEdit from "./UserProfileEdit";
import UserDailyItems from "./UserDailyItems";
import PendingAssignments from "./PendingAssignments";

const UserDashboardNew = ({ user }) => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);

  const handleProfileUpdate = (updatedUser) => {
    setCurrentUser(updatedUser);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "calendar":
        return <CalendarView user={currentUser} />;
      case "delivery-tracking":
        return <DeliveryTracking user={currentUser} />;
      case "daily-items":
        return <UserDailyItems user={currentUser} />;
      case "pending-assignments":
        return <PendingAssignments />;
      case "dashboard":
      default:
        return (
          <div className="card">
            <div className="text-center">
              <h1>Welcome to Your Dashboard!</h1>
              <p style={{ fontSize: "18px", color: "#666", marginTop: "20px" }}>
                Hello {currentUser.username}, you are successfully logged in as
                a user.
              </p>
            </div>

            <div style={{ marginTop: "40px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h2>Your Profile Information</h2>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowProfileEdit(true)}
                >
                  ✏️ Edit Profile
                </button>
              </div>
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "20px",
                  borderRadius: "8px",
                  marginTop: "20px",
                }}
              >
                {currentUser.uniqueUserId && (
                  <div style={{ marginBottom: "20px" }}>
                    <strong>Your User ID:</strong>
                    <div
                      style={{
                        marginTop: "8px",
                        display: "inline-block",
                      }}
                    >
                      <span
                        style={{
                          color: "#fff",
                          fontFamily: "monospace",
                          fontSize: "18px",
                          fontWeight: "bold",
                          backgroundColor: "#007bff",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: "2px solid #0056b3",
                          letterSpacing: "2px",
                          boxShadow: "0 2px 8px rgba(0, 123, 255, 0.3)",
                        }}
                      >
                        {currentUser.uniqueUserId}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginTop: "5px",
                        fontStyle: "italic",
                      }}
                    >
                      Use this ID for identification purposes
                    </div>
                  </div>
                )}
                <div style={{ marginBottom: "15px" }}>
                  <strong>Username:</strong> {currentUser.username}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <strong>Email:</strong> {currentUser.email}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <strong>Name:</strong> {currentUser.firstName}{" "}
                  {currentUser.lastName}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <strong>Phone:</strong>{" "}
                  {currentUser.phoneNumber || "Not provided"}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <strong>Role:</strong>{" "}
                  {currentUser.role || currentUser.accountType}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <strong>Account Status:</strong>
                  <span style={{ color: "#28a745", marginLeft: "10px" }}>
                    Active
                  </span>
                </div>
                {currentUser.address && (
                  <div style={{ marginBottom: "15px" }}>
                    <strong>Address:</strong> {currentUser.address.street},{" "}
                    {currentUser.address.city}, {currentUser.address.state}{" "}
                    {currentUser.address.zipCode}
                  </div>
                )}
              </div>

              <div style={{ marginTop: "30px" }}>
                <h2>Quick Actions</h2>
                <div style={{ marginTop: "20px" }}>
                  <button
                    className="btn btn-primary"
                    style={{ marginRight: "10px", marginBottom: "10px" }}
                    onClick={() => setActiveTab("calendar")}
                  >
                    📅 View Calendar
                  </button>
                  <button
                    className="btn btn-secondary"
                    style={{ marginRight: "10px", marginBottom: "10px" }}
                    onClick={() => setActiveTab("delivery-tracking")}
                  >
                    🚚 Track Deliveries
                  </button>
                  <button
                    className="btn btn-warning"
                    style={{ marginRight: "10px", marginBottom: "10px" }}
                    onClick={() => setActiveTab("pending-assignments")}
                  >
                    📋 Pending Assignments
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="container">
      <div className="dashboard-tabs" style={{ marginBottom: "30px" }}>
        <button
          className={`dashboard-tab ${
            activeTab === "dashboard" ? "active" : ""
          }`}
          onClick={() => setActiveTab("dashboard")}
        >
          <div className="dashboard-tab-icon">🏠</div>
          <div className="dashboard-tab-label">Dashboard</div>
        </button>
        <button
          className={`dashboard-tab ${
            activeTab === "delivery-tracking" ? "active" : ""
          }`}
          onClick={() => setActiveTab("delivery-tracking")}
        >
          <div className="dashboard-tab-icon">🚚</div>
          <div className="dashboard-tab-label">My Deliveries</div>
        </button>
        <button
          className={`dashboard-tab ${
            activeTab === "daily-items" ? "active" : ""
          }`}
          onClick={() => setActiveTab("daily-items")}
        >
          <div className="dashboard-tab-icon">📦</div>
          <div className="dashboard-tab-label">My Daily Items</div>
        </button>
        <button
          className={`dashboard-tab ${
            activeTab === "pending-assignments" ? "active" : ""
          }`}
          onClick={() => setActiveTab("pending-assignments")}
        >
          <div className="dashboard-tab-icon">📋</div>
          <div className="dashboard-tab-label">Pending Assignments</div>
        </button>
        <button
          className={`dashboard-tab ${
            activeTab === "calendar" ? "active" : ""
          }`}
          onClick={() => setActiveTab("calendar")}
        >
          <div className="dashboard-tab-icon">📅</div>
          <div className="dashboard-tab-label">Calendar</div>
        </button>
      </div>

      {renderTabContent()}

      {showProfileEdit && (
        <UserProfileEdit
          user={currentUser}
          onProfileUpdate={handleProfileUpdate}
          onCancel={() => setShowProfileEdit(false)}
        />
      )}
    </div>
  );
};

export default UserDashboardNew;
